<template>
  <div>
    <el-form ref="form" :rules="rules" :model="dioForm" label-width="180px" v-if="dioForm">
      <el-form-item prop="name" :label="$t('customer.name')">
        <el-input
          type="text"
          v-model.trim="dioForm.name"
          :placeholder="$t('customer.name_placeholder')"
          style="width: 250px"
        ></el-input>
        <i
          class="el-icon-back"
          style="float: right; cursor: pointer; color: var(--primary-color)"
          :title="$t('customer.mode_lookup')"
          @click="goBackSeeMode"
        ></i>
      </el-form-item>

      <el-form-item prop="code" :label="$t('customer.customer_code')">
          <el-input type="text" v-model.trim="dioForm.code" :placeholder="$t('customer.customer_code_placeholder')" style="width: 250px" disabled></el-input>
        </el-form-item>

        <el-form-item prop="status" :label="$t('customer.customer_status')">
          <el-select v-model="dioForm.status" style="width: 250px">
            <el-option v-for="item in statusArray" :key="item.value" :value="item.value" :label="$t(item.label)"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="address" :label="$t('customer.address')">
        <div class="uk-flex uk-flex-middle">
          <el-input type="text" v-model.trim="dioForm.address" :placeholder="$t('customer.address_placeholder')" style="width: 250px"></el-input>
          <div class="uk-margin-small-left">
            <el-button @click="toLocate" icon="el-icon-location-outline"></el-button>
          </div>
        </div>
      </el-form-item>

      <el-form-item prop="contact" :label="$t('customer.contact')">
        <el-input type="text" v-model.trim="dioForm.contact" :placeholder="$t('customer.contact_placeholder')" style="width: 250px"></el-input>
      </el-form-item>

      <el-form-item prop="phone" :label="$t('customer.phone')">
        <el-input type="text" v-model.trim="dioForm.phone" :placeholder="$t('customer.phone_placeholder')" style="width: 250px"></el-input>
      </el-form-item>

      <el-form-item prop="email" :label="$t('customer.email')">
        <el-input type="text" v-model.trim="dioForm.email" :placeholder="$t('customer.email_placeholder')" style="width: 250px"></el-input>
      </el-form-item>

      <el-form-item :label="$t('integration.monitoring_point_type')" prop="monitorType" required>
        <el-select v-model="dioForm.monitorType" multiple style="width: 250px">
          <el-option
            v-for="(item, key) in carrierTypeList"
            :key="key"
            :label="currentLanguage === 'zh_CN' ? item.name : item.code"
            :value="parseInt(key)"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('customer.description')" prop="description">
        <el-input
          v-model.trim="dioForm.description"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          style="width: 250px; margin-left:-5px"
          maxlength="250"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>

    <!-- 定位组件 -->
    <Locate :showLocate.sync="showLocate" v-if="showLocate" :dioForm.sync="dioForm"></Locate>
  </div>
</template>

<script>
import Locate from './Locate.vue';
import { getLanguage } from '@/lang';

export default {
  name: 'EditDialog', // 建议添加 name 属性，便于调试
  props: {
    statusArray: {
      type: Array,
      default: () => []
    },
    typeArray: {
      type: Array,
      default: () => []
    },
    editObj: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Locate
  },
  data() {
    return {
      showLocate: false,
      dioForm: null,
      currentLanguage: getLanguage(), // 缓存语言环境，避免在模板中重复调用方法
      carrierTypeList: this.$store.state.carrierType || {} // 缓存 store 数据
    };
  },
  computed: {
    // 将 rules 移入 computed，确保 $t 函数的响应式生效
    rules() {
      return {
        name: [
          { required: true, message: this.$t('integration.customer_name_cannot_be_empty'), trigger: 'blur' },
          { max: 50, message: this.$t('integration.length_within_50'), trigger: 'blur' }
        ],
        short_name: [
          { max: 30, message: this.$t('public.len_max_30'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$t('integration.customer_code_cannot_be_empty'), trigger: 'blur' },
          { max: 20, message: this.$t('integration.length_within_20'), trigger: 'blur' },
          { validator: this.$fromRules.FormValidate.Form().Codes, trigger: 'blur' }
        ],
        status: [
            { required: true, message: this.$t('integration.customer_status_cannot_be_empty'), trigger: 'change' }
          ],
          address: [
          { max: 255, message: this.$t('integration.length_within_255'), trigger: 'blur' }
        ],
        contact: [
          { required: true, message: this.$t('integration.contact_cannot_be_empty'), trigger: 'blur' },
          { max: 30, message: this.$t('public.len_max_30'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('integration.contact_information_cannot_be_empty'), trigger: 'blur' },
          { max: 30, message: this.$t('public.len_max_30'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('integration.mailbox_cannot_be_empty'), trigger: 'blur' },
          { max: 255, message: this.$t('integration.length_within_255'), trigger: 'blur' },
          { type: 'email', message: this.$t('integration.please_enter_the_correct_email_address'), trigger: ['blur', 'change'] }
        ],
        monitorType: [
          { required: true, message: this.$t('integration.select_at_least_one_monitoring_point_type'), trigger: 'change' }
        ]
      };
    }
  },
  methods: {
    toLocate() {
      this.showLocate = true;
    },
    goBackSeeMode() {
      this.$emit('seeMode');
    },
    // 暴露给父组件调用的清空验证方法
    clearValidate() {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    // 暴露给父组件调用的验证方法
    async justify() {
      try {
        return await this.$refs.form.validate();
      } catch (error) {
        return false;
      }
    }
  },
  mounted() {
    // 1. 【核心修复】深拷贝数据，断开与父组件引用，解决无法输入问题
    if (this.editObj && this.editObj.customer) {
      // 使用深拷贝创建本地副本，避免修改父组件数据
      this.dioForm = JSON.parse(JSON.stringify(this.editObj.customer));

      // 2. 安全地初始化 monitorType
      const types = this.editObj.carrierTypeApplyList
        ? this.editObj.carrierTypeApplyList.map(item => item.carrierTypeId)
        : [];

      // 使用 $set 保证新增属性也是响应式的
      this.$set(this.dioForm, 'monitorType', types);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  border-radius: 2px;
  margin-left: 5px;
}
</style>
